import { render } from "./weekGeneral.vue?vue&type=template&id=32fba4e3"
import script from "./weekGeneral.vue?vue&type=script&lang=js"
export * from "./weekGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__